 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"bundles/inbox.js": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "../static-" + (["1.63798","1.63825","1.56642","1.62806","1.63823","1.63437","1.63794","1.63743","1.63811","1.63824","1.56197","1.63615","1.60234","1.63549","1.60478","1.60481"][{"0":0,"1":1,"2":2,"3":1,"associated-objects-card-content~connected-message-composer-alert-tray~inbox-zero-state":0,"associated-objects-card-content~deal-conversations-card-content~properties-card~thread-ticket-card-c~f209eab2":3,"associated-objects-card-content":1,"contact-tickets-card-content~contact-tickets-card-title~thread-ticket-card-content":3,"properties-card~thread-ticket-card-content":1,"thread-ticket-card-content":4,"deal-conversations-card-content~deal-conversations-card-title":5,"deal-conversations-card-content":6,"properties-card":7,"batch-thread-operations-container":6,"block-thread-prompt":6,"calling-widget":1,"contact-tickets-card-content":5,"contact-tickets-card-title":5,"conversations-inbox-ui-lang-da":8,"conversations-inbox-ui-lang-de":8,"conversations-inbox-ui-lang-es":8,"conversations-inbox-ui-lang-fi":8,"conversations-inbox-ui-lang-fr":8,"conversations-inbox-ui-lang-it":8,"conversations-inbox-ui-lang-ja":8,"conversations-inbox-ui-lang-nl":8,"conversations-inbox-ui-lang-no":8,"conversations-inbox-ui-lang-pl":8,"conversations-inbox-ui-lang-pt-br":9,"conversations-inbox-ui-lang-sv":8,"conversations-inbox-ui-lang-zh-tw":8,"conversations-taxonomy-card-content":10,"create-custom-view~delete-view-modal~edit-custom-view":11,"create-custom-view~edit-custom-view":9,"create-custom-view":11,"edit-custom-view":0,"delete-view-modal":11,"customer-summary-card-title":10,"deal-conversations-card-title":12,"emoji-picker":5,"file-manager":13,"more-actions-dropdown":4,"move-inbox-card-content":10,"not-installed-alert":6,"past-conversations-card-content":6,"past-feedback-card-title":14,"qualified-leads-card-content":10,"rep-chat-assignment-card-content":10,"send-chat-transcript-prompts":15,"tool-links-card-content":10,"verify-install-prompt":6,"zorse-ticket-search-card-content":10}[chunkId]] || "1.63826") + "/" + chunkId + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}


 	var dlbs = [{"name":"head-dlb/bundle.production.js","path":"head-dlb/static-1.876/bundle.production.js","ids":{}},{"name":"svh-workspace-dlb/bundles/runtime.production.js","path":"svh-workspace-dlb/static-1.73/bundles/runtime.production.js","ids":{"immutable":"QYOI","react":"Ktcs","hoist-non-react-statics":"5z3Z","enviro":"LZPL","prop-types":"VfuR","react-is":"dXZi","react/jsx-runtime":"QgEn","react-dom":"r1tY","classnames":"t6nY"}},{"name":"apollo-dlb/bundle.production.js","path":"apollo-dlb/static-3.26/bundle.production.js","ids":{"graphql/language/visitor":"E/ol","graphql/language/printer":"Pme8","graphql/language/kinds":"/Hx1","graphql/language/predicates":"b2Eo","apollo-stack-hubspot/internal/graphql-tag/lib/index":"TJgy","react":"Ktcs"}},{"name":"hubspot-dlb/bundle.production.js","path":"hubspot-dlb/static-1.716/bundle.production.js","ids":{"enviro":"LZPL"}}];
 	__webpack_require__.dlbpr = function(dlbId, id) {
 	  var dlb = dlbs[dlbId];
 	  if (!dlb.r) {
 	    dlb.r = window['__webpack_require_' + dlb.name + '__'];
 	    if (!dlb.r) {
 	      throw new Error('dlb ' + dlb.name + ' not loaded');
 	    }
 	    // the first time a dlb module is required, we link it
 	    dlb.r.linkDlb(__webpack_require__, dlb.ids);
 	  }
 	  return dlb.r(id);
 	}
 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var head = document.getElementsByTagName('head')[0];
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				if (script.src.indexOf(window.location.origin + '/') !== 0) {
 					script.crossOrigin = "anonymous";
 				}
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "//static.hsappstatic.net/conversations-inbox-ui/static-1.63826/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = "PvgP");
